import * as React from 'react';

import { IconColors } from '../../Icons/IconColors';

export interface IconWithTextDefaults {
    color?: IconColors;
    textSize?: string;
    iconAspect?: string;
    /** Sentence case, lighter weight and a wider icon gap, the action menu treatment. */
    compact?: boolean;
}

/**
 * Lets a container (an action menu) restyle the `IconWithText`s its children happen to
 * render. Props passed by those children always win, so a destructive action keeps its red.
 */
export const IconWithTextDefaultsContext = React.createContext<IconWithTextDefaults>({});
